module.exports = __webpack_public_path__ + "assets/store.f051f069.svg";